import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Account, DashboardRecord } from '@app/_models';
import { DashboardClientStatus } from '@app/_models/dashboard/dashboardClientStatus'
import { environment } from '@environments/environment';
import { FormGroupDirective } from '@angular/forms';

const baseUrl = `${environment.apiUrl}/dashboard`;

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private router: Router,
    private http: HttpClient) { }


  getCaseList({ id, sortDir = 'desc', sortCol = 'Id', pageSize, pageNumber }: { id: string, sortDir?: string, sortCol?: string, pageSize?: number, pageNumber?: number }): Observable<any[]> {
    return this.http.get<any>(`${baseUrl}/getCaseList?id=${id}&sortDir=${sortDir}&sortCol=${sortCol}&pageSize=${pageSize}&pageNumber=${pageNumber}`);
  }

  resendCandidateEmail(caseID: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${baseUrl}/resendCandidateEmail`, `{"caseID": ${caseID}}`, { headers: headers });
  }

  getPDF(url : string): Observable<any>
  {


      const headers = new HttpHeaders({ 'Content-Type': 'application/json',
      responseType : 'blob'});

      return this.http.get<Blob>(url, { headers : headers,responseType :
      'blob' as 'json'});
  }

  cancelOrderById(orderID: number, email: string){
    return this.http.post(`${baseUrl}/cancelOrderById`, {'orderID': orderID, 'clientEmail': email});
  }


  getOutstandingBalances({ id, sortDir = 'desc', sortCol = 'Id', pageSize = 10 }: { id: string, sortDir?: string, sortCol?: string, pageSize?: number }): Observable<DashboardClientStatus>{
    return this.http.get<any>(`${baseUrl}/getOutstandingBalances?id=${id}&sortDir=${sortDir}&sortCol=${sortCol}&pageSize=${pageSize}`);
  }

  updateApplicantEmail(id: number, email: string)
  {
      return this.http.post(`${baseUrl}/UpdateApplicantEmail`, {'caseId': id, 'email': email});
  }
}
